import { Buffer } from 'buffer'
import { buildIpcShim } from './browser-ipc-shim'
import { detectPlatform } from './browser-utils'

const isElectronRenderer = (): boolean => {
  return (
    window.process?.type === 'renderer' &&
    window.process.contextId !== 'browser' &&
    typeof window.ipc?.channels !== 'undefined'
  )
}

/**
 * Runs from its own module script before the app entry. `@highlight/ipc`
 * constructs GlobalState while the module evaluates, so `window.process` and
 * `window.ipc` have to exist before that import.
 */
export const installBrowserRuntimePrelude = (): void => {
  if (typeof globalThis.Buffer === 'undefined') {
    globalThis.Buffer = Buffer
  }

  if (isElectronRenderer()) {
    return
  }

  if (!window.process || window.process.type !== 'renderer' || window.process.contextId !== 'browser') {
    const nodeEnv = import.meta.env.DEV ? 'development' : 'production'
    window.process = {
      contextId: 'browser',
      pid: 1,
      platform: detectPlatform(),
      type: 'renderer',
      env: {
        NODE_ENV: nodeEnv,
      },
    }
  }

  if (!window.ipc?.channels) {
    window.ipc = buildIpcShim()
  }
}

installBrowserRuntimePrelude()
